<template>
  <div>
    <div class="flex items-end justify-end gap-10">
      <DateRangePicker
        ref="picker"
        v-model="dateRange"
        :locale-data="locale"
        opens="center"
        :show-ranges="false"
        :ranges="false"
      />
      <div
        class="d-flex rounded-lg align-items-center border search-bar"
      >
        <span
          class="k-search-normal-1 h-100 font-bold align-middle mx-[5px]"
          style="font-size: 20px"
        />
        <BFormInput
          v-model="search"
          placeholder="Search card name / 4 last card number"
          class="border-0"
          @input="searchData"
        />
      </div>
    </div>
    <BButton
      v-for="btn in buttons"
      :key="btn.id"
      class="mr-1 mt-1"
      :disabled="!enabledActionIds.has(btn.id)"
      :variant="!enabledActionIds.has(btn.id) ? 'secondary' : 'primary'"
      @click="onAction(btn.label)"
    >
      <span :class="btn.icon" />
      {{ btn.label }}
    </BButton>
    <BOverlay
      :show="loadingTable"
      spinner-variant="primary"
      variant="light"
      class="mt-[16px]"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        class="mt-1"
        style="height: calc(100vh - 250px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data"
          responsive
        >
          <template #head(checkbox)>
            <div class="d-flex justify-content-center">
              <BCheckbox
                v-model="allSelected"
                @change="onChangeSelectAll"
              />
            </div>
          </template>
          <template #cell(checkbox)="data">
            <div class="d-flex justify-content-center">
              <BCheckbox
                v-model="selected"
                :value="data.item"
                @change="onSelected"
              />
            </div>
          </template>
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(name)="data">
            <div class="flex items-start gap-8">
              <span
                v-b-tooltip.hover.top="`${data.item.level === 'platinum' ? 'Platinum' : data.item.level === 'gold' ? 'Gold' : 'Bronze'}`"
                class="k-card text-[20px]"
                :class="data.item.level === 'platinum'
                  ? 'text-[#757F9A]'
                  : data.item.level === 'gold'
                    ? 'text-[#F6B732]'
                    : 'text-[#CD7F32]'"
              />
              <div class="flex flex-col gap-4">
                <div class="text-[14px] gap-[4px] flex items-center">
                  <span class="text-[#333333] font-semibold text-nowrap capitalize">
                    {{ data.item.name }}
                  </span>
                  <div class="text-[#626262]">
                    {{ `***${data.item.last_number}` }}
                  </div>
                </div>
                <div class="flex items-center !gap-2">
                  <span class="text-[#828282]">Card id: {{ data.item.card_uuid.substring(0, 13) + "..." }}</span>
                  <img
                    src="https://storage.googleapis.com/komerce/assets/copy.svg"
                    width="20"
                    class="cursor-pointer"
                    @click="copyCardId(data.item.card_uuid)"
                  >
                </div>
                <span class="text-[#333333] flex text-[14px] text-nowrap gap-[4px] items-center">
                  <div
                    class="h-[8px] w-[8px] rounded-full"
                    :class="color(data.item.status)"
                  />
                  <div>{{ status(data.item.status) }}</div>
                </span>
              </div>
              <!-- <img
                v-if="data.item.labels"
                v-b-popover.hover.top="data.item.labels"
                src="https://storage.googleapis.com/komerce/assets/svg/button-cards.svg"
                alt="tag"
                width="20"
                class="cursor-pointer"
              > -->
            </div>
          </template>
          <template #cell(decline_transactions)="data">
            <span v-if="!isEmpty(data.item.decline_transactions)">
              <div
                v-for="(item, idx) in data.item.decline_transactions"
                :key="idx"
              >
                <span>{{ item.decline_type }} ({{ item.total_decline }}x)</span>
              </div>
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(spending_category)="data">
            <span v-if="!isEmpty(data.item.spending_category)">
              <div
                v-for="(item, idx) in data.item.spending_category"
                :key="idx"
              >
                <span class="capitalize">{{ item.category }} ({{ item.percentage }}%)</span>
              </div>
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(more)="data">
            <span class="flex justify-center">
              <BDropdown
                variant="none"
                no-caret
                size="sm"
                offset="-100"
                block
                menu-class="font-medium mb-[-30px]"
                @show="
                  handleOpenOption({
                    id: data.item.id,
                    last_number: data.item.last_number,
                    name: data.item.label,
                    card_id: data.item.card_uuid,
                    balance: data.item.daily_limit,
                  })
                "
              >
                <template #button-content>
                  <button class="bg-transparent">
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                      alt="more-icon"
                    >
                  </button>
                </template>
                <div class="w-[200px]">
                  <!-- <div
                    v-if="data.item.level === 'platinum'"
                    :class="
                      data.item.status === 'active'
                        ? 'cursor-pointer text-[#626262] hover:bg-[#f8f8f8]'
                        : 'text-[#c2c2c2]'
                    "
                    class="flex gap-[3px] py-[5px] items-center px-[4px] text-[14px]"
                    @click="handleDailyLimit(data.item.status)"
                  >
                    <span
                      class="k-card-edit text-[20px]"
                      alt="edit"
                    />
                    <div class="text-nowrap ml-[4px]">Ubah Limit Harian</div>
                  </div> -->
                  <div
                    class="flex py-[5px] cursor-pointer gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    @click="
                      handleCompareBalance({
                        id: data.item.id,
                        last_number: data.item.last_number,
                        name: data.item.name,
                        card_id: data.item.card_uuid,
                      })
                    "
                  >
                    <span
                      class="k-eye text-[20px]"
                      alt="eye"
                    />
                    <div class="text-nowrap ml-[4px]">Cek Selisih Saldo</div>
                  </div>
                  <div
                    class="flex gap-[3px] py-[5px] cursor-pointer items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px] "
                    @click="
                      $router.push(
                        '/komcards-data-partner/mutation/' + data.item.id
                      )
                    "
                  >
                    <span
                      class="k-diagram text-[20px]"
                      alt="diagram"
                    />
                    <div class="text-nowrap ml-[4px]">Lihat Mutasi</div>
                  </div>
                  <div
                    class="flex gap-[3px] py-[5px] cursor-pointer items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px] "
                    @click="syncTransaction(data.item.id)"
                  >
                    <span
                      class="k-clipboard-export text-[20px]"
                      alt="diagram"
                    />
                    <div class="text-nowrap ml-[4px]">Sync Transaksi</div>
                  </div>
                </div>
              </BDropdown>
            </span>
          </template>
        </BTable>
      </div>
    </BOverlay>
    <ModalDailyLimit
      :id="activeChooseId.id"
      :name="activeChooseId.name"
      :last-number="activeChooseId.lastNumber"
      :daily-limit="activeChooseId.daily_limit"
      @close="handleCloseModalDailyLimit"
    />
    <ModalCompareBalance
      :balance="activeCompareBalance.balance"
      :diff_balance="activeCompareBalance.diff_balance"
      :card_id="activeCompareBalance.card_id"
      :hold_balance="activeCompareBalance.hold_balance"
      :last_number="activeCompareBalance.last_number"
      :name="activeCompareBalance.name"
      :real_balance="activeCompareBalance.real_balance"
      :daily_limit_internal="activeCompareBalance.daily_limit_internal"
      :daily_limit_bank="activeCompareBalance.daily_limit_bank"
      :voucher_balance="activeCompareBalance.voucher_balance"
    />

    <ModalAction
      :card-ids="card_ids"
      :title="modalTitle"
      @onRefetch="getList"
      @onChangeSelectAll="onChangeSelectAll"
      @onSelected="onSelected"
    />
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import isEmpty from 'lodash/isEmpty'
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY,
} from '@/libs/filterDate'
import DateRangePicker from 'vue2-daterange-picker'
import { firstDateOfMonth, today } from '@/store/helpers'
import ModalDailyLimit from './ModalDailyLimit.vue'
import ModalCompareBalance from './ModalCompareBalance.vue'
import columnConfig from './config'
import ModalAction from './Action.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    ModalDailyLimit,
    ModalCompareBalance,
    DateRangePicker,
    ModalAction,
  },
  data() {
    return {
      isEmpty,
      YEAR_MONTH_DAY,
      loadingTable: false,
      lastData: false,
      locale: {
        format: 'dd mmm yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
        applyLabel: 'Pilih',
        cancelLabel: 'Kembali',
      },
      dateRange: {
        startDate: firstDateOfMonth,
        endDate: today,
      },
      items: null,
      IDR,
      offset: 0,
      limit: 25,
      search: '',
      fields: columnConfig,
      card_ids: [],
      activeChooseId: {
        name: null,
        lastNumber: null,
        id: null,
        daily_limit: null,
      },
      activeCompareBalance: {
        balance: null,
        hold_balance: null,
        real_balance: null,
        daily_limit_bank: null,
        daily_limit_internal: null,
        voucher_balance: null,
        name: null,
        last_number: null,
        card_id: null,
        diff_balance: null,
      },
      selected: [],
      allSelected: false,
      modalTitle: null,
      buttons: [
        { id: 0, label: 'Freeze Kartu', icon: 'k-card-tick-1' },
        { id: 1, label: 'Unfreeze Kartu', icon: 'k-card-remove' },
        { id: 2, label: 'Cancel Kartu', icon: 'k-trash' },
      ],
    }
  },
  computed: {
    uniqueStatuses() {
      return new Set(this.selected.map(x => String(x.status)))
    },
    enabledActionIds() {
      const statuses = this.uniqueStatuses

      const sets = {
        none: new Set(),
        all: new Set([0, 1, 2]),
        freeze: new Set([0, 2]), // active → Freeze + Cancel
        unfreeze: new Set([1, 2]), // freeze → Unfreeze
      }

      const allowed = new Set(['active', 'inactive', 'freeze'])
      const forbidden = new Set(['cancel', 'pending'])

      const { size } = statuses
      const has = s => statuses.has(s)
      const everyIn = (src, targetSet) => [...src].every(v => targetSet.has(v))
      const anyIn = (src, targetSet) => [...src].some(v => targetSet.has(v))

      const ruleList = [
        [() => this.selected.length === 0, sets.none],
        [() => anyIn(statuses, forbidden), sets.none],
        [() => size === 1 && has('active'), sets.freeze],
        [() => size === 1 && has('freeze'), sets.unfreeze],
        [() => everyIn(statuses, allowed) && size > 1, sets.all],
        [() => true, sets.none],
      ]

      return (ruleList.find(([cond]) => cond()) || [null, sets.none])[1]
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.getList()
      },
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    async syncTransaction(id) {
      const url = `komcards/api/v1/card/${id}/sync`

      try {
        const data = await newAxiosIns.request({
          method: 'post',
          url,
          params: {
            card_id: id,
          },
        })

        if (data.status === 200) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Berhasil',
              icon: 'CheckIcon',
              text: 'Proses synchronize transaksi sedang berlangsung',
              variant: 'success',
            },
          }, { timeout: 3000 })
          return
        }
      } catch (error) {
        const meta = JSON.parse(error.request.response)

        if (meta.meta.message === 'pending process found, cannot proceed') {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Kesalahan',
              icon: 'XCircleIcon',
              text: 'Tidak bisa melakukan synchronize transaksi sekarang, karena ada proses yang berlangsung',
              variant: 'danger',
            },
          }, { timeout: 3000 })
          return
        }

        this.$toast_error({ message: 'Gagal sync data kartu' })
      }
    },
    convertDesimal(value) {
      return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value)
    },
    async handleCloseModalDailyLimit() {
      this.offset = 0
      this.getList()
    },
    getNextData() {
      const { id } = this.$route.params

      if (!this.lastData) {
        this.loadingTable = true
        const params = {
          user_id: id,
          offset: this.offset,
          limit: this.limit,
          search: this.search,
          filter_start_date: YEAR_MONTH_DAY(this.dateRange.startDate),
          filter_end_date: YEAR_MONTH_DAY(this.dateRange.endDate),
        }

        const url = 'komcards/api/v1/admin/card/list'

        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data } = res.data
            const normalizeData = !isEmpty(data) ? data : []
            this.items.push(...normalizeData)
            this.offset += data.length
            this.loadingTable = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loadingTable = false
            this.$toast_error({ message: 'Gagal load data' })
          })
      }
    },
    searchData: _.debounce(function search() {
      this.getList()
    }, 1000),
    handleOpenOption(objectProps) {
      const {
        id, last_number, name, balance,
      } = objectProps

      this.activeChooseId.id = id
      // eslint-disable-next-line camelcase
      this.activeChooseId.lastNumber = last_number
      this.activeChooseId.name = name
      this.activeChooseId.daily_limit = balance
    },
    handleScroll() {
      const table = document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 5
        && !this.loadingTable
        && !this.lastData
      ) {
        this.getNextData()
      }
    },
    handleDailyLimit(status) {
      if (status === 'active') {
        this.$bvModal.show('modal-limit-daily')
      }
    },
    async handleCompareBalance(objectProps) {
      const {
        id, last_number, name, card_id,
      } = objectProps

      const url = `komcards/api/v1/card/${id}/info-balance`

      try {
        const data = await newAxiosIns.request({
          method: 'get',
          url,
        })

        if (data.status === 200) {
          this.activeCompareBalance = data.data.data

          this.activeCompareBalance = {
            id,
            last_number,
            name,
            card_id,
            ...this.activeCompareBalance,
          }

          this.$bvModal.show('modal-compare-balance')

          return
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal load data' })
        return
      }

      this.$bvModal.show('modal-compare-balance')
    },
    async getList() {
      this.loadingTable = true
      const { id } = this.$route.params
      this.offset = 0

      const params = {
        user_id: id,
        offset: this.offset,
        limit: this.limit,
        search: this.search,
        filter_start_date: YEAR_MONTH_DAY(this.dateRange.startDate),
        filter_end_date: YEAR_MONTH_DAY(this.dateRange.endDate),
      }

      const url = 'komcards/api/v1/admin/card/list'
      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          const normalizeData = !isEmpty(data) ? data : []
          this.loadingTable = false
          this.offset = normalizeData.length
          this.items = normalizeData
          if (normalizeData.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
          this.loadingTable = false
        })
    },
    handleResetLimit() {
      this.activeChooseId = {}
    },
    async copyCardId(value) {
      navigator.clipboard.writeText(value)
      this.$toast_success({ message: `Card id ${value} berhasil di copy` })
    },
    onChangeSelectAll(checked) {
      const allowed = new Set(['active', 'inactive', 'freeze'])
      this.selected = checked ? this.items.filter(i => allowed.has(i.status)) : []
      this.allSelected = checked
    },
    onSelected() {
      this.allSelected = false
    },
    onAction(title) {
      this.modalTitle = title

      const status = {
        'Freeze Kartu': this.selected.filter(e => e.status === 'active'),
        'Unfreeze Kartu': this.selected.filter(e => e.status === 'freeze'),
        'Cancel Kartu': this.selected.filter(e => ['active', 'inactive', 'freeze'].includes(e.status)),
      }

      this.card_ids = status[title].map(e => e.id)
      this.$bvModal.show('modal-action')
    },
    status(value) {
      const data = {
        active: 'Aktif',
        inactive: 'Tidak Aktif',
        pending: 'Pending',
        freeze: 'Dibekukan',
        cancel: 'Dibatalkan',
      }

      return data[value]
    },
    color(value) {
      const data = {
        active: 'bg-[#34A770]',
        inactive: 'bg-[#E31A1A]',
        pending: 'bg-[#c2c2c2]',
        freeze: 'bg-[#828282]',
        cancel: 'bg-[#828282]',
      }

      return data[value]
    },
  },
}
</script>

<style scoped></style>
